import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableBillingCommissions = Loadable({
  loader: function loader() {
    return import('../BillingCommissions.jsx');
  },
  loading: ComponentLoading
});
export default LoadableBillingCommissions;